import { Button, Grid, Stack, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

import { CircularProgress, TextInput } from '@hapvida/hapvida-core-components';

import { applyCpfMask } from '@utils';
import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import { useUserDataAccess } from './hooks';
import type { HandleOnChangeProps } from './types';

export function UserDataAccess() {
  const { control, errors, handleSubmit, onSubmit, isValid, loading } =
    useUserDataAccess();

  const { isMobileOrTablet } = useDeviceBreakpoints();

  const handleOnChange = ({
    event,
    onChange,
    value,
  }: HandleOnChangeProps): void => {
    const input = event.target as HTMLInputElement;
    const cursorPosition = input.selectionStart ?? 0;

    const { maskedText, newCursorPosition, shouldChangeInput } = applyCpfMask({
      currentValue: input.value,
      cursorPosition,
      previewValue: value,
    });

    if (shouldChangeInput) {
      onChange(maskedText);
    }

    if (cursorPosition !== null) {
      window.requestAnimationFrame(() => {
        input.setSelectionRange(newCursorPosition, newCursorPosition);
      });
    }
  };

  return (
    <Stack gap={2}>
      <Typography variant="h5">Bem-vindo ao novo Portal Empresa</Typography>
      <Grid component="form" container spacing={{ xs: 5, sm: 3 }}>
        <Grid item xs={12}>
          <Typography variant="text">
            Para completar o seu cadastro, informe o seu CPF.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Controller
            name={'document'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextInput
                control={control}
                name="document"
                fullWidth
                error={Boolean(errors?.document?.message)}
                helperText={errors?.document?.message}
                label="CPF"
                onChange={event => handleOnChange({ event, onChange, value })}
                required
                placeholder="Digite o seu CPF"
              />
            )}
          />
        </Grid>

        <Grid item xs={12} container justifyContent="flex-end">
          <Button
            variant="contained"
            color="success"
            endIcon={loading ? <CircularProgress size={16} /> : null}
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid || loading}
            type="submit"
            fullWidth={isMobileOrTablet}
            sx={{
              mt: isMobileOrTablet ? '24px' : 0,
            }}
          >
            Avançar
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
}
